import * as React from 'react'

import {getSingleAgentArg} from '../../../../../rest/agents'
import {getSingleAgent} from '../../../../../selectors'
import {restApi} from '../../../../../services/rest'
import type {AgentId, NormalizedAgent} from '../../../../../types'
import {extractError} from '../../../../../utils/extractError'
import {subscribeOnAgent} from '../../AgentsPages.actions'
import {useSubscribeOnAgentRemoval} from '../../AgentsPages.hooks'

import {useAppDispatch, useAppSelector} from 'src/hooks/react-redux'

const AgentFetcher = ({
  agentId,
  children,
}: {
  agentId: AgentId
  children: (arg0: {
    loading: boolean
    ready: boolean
    error?: Error | null | undefined
    agent: NormalizedAgent | null | undefined
  }) => React.ReactElement
}): React.ReactElement => {
  const {loading, ready, error} = restApi.endpoints.getAgentNormalized.useQuery(
    getSingleAgentArg(agentId),
    {
      selectFromResult: ({isLoading, data, error}) => ({
        loading: isLoading,
        ready: data != null,
        error,
      }),
    },
  )
  const agent = useAppSelector(state => getSingleAgent(state, agentId))
  const dispatch = useAppDispatch()
  React.useEffect(() => dispatch(subscribeOnAgent(agentId, {})), [agentId, dispatch])
  useSubscribeOnAgentRemoval(agentId)
  const extractedError = extractError(error)
  return children({
    loading,
    ready,
    error: typeof extractedError === 'string' ? new Error(extractedError) : extractedError,
    agent,
  })
}

export default AgentFetcher
